import { gql } from '@apollo/client'

export const validateFundClaimToken = gql`
  query ValidateFundClaimToken($token: String!) {
    validateFundClaimToken(token: $token)
  }
`

export const getFundClaimDetails = gql`
  query GetFundClaimDetails($token: String!) {
    getFundClaimDetails(token: $token) {
      fundId
      fundName
      fundNumber
      clientEmail
      clientFirstName
      clientLastName
      corporateName
      fundType
      advisorName
      advisorEmail
      expiresAt
      status
      requiresTermsAcceptance
      isActivatedAccount
      otherPendingInvites {
        token
        advisorName
      }
    }
  }
`

export const lookupClientByEmail = gql`
  query LookupClientByEmail($email: String!) {
    lookupClientByEmail(email: $email) {
      exists
      firstName
      middleInitials
      lastName
      phone
      corporateName
      identityKind
      hasDonorFund
    }
  }
`

export const myPendingFundClaimInvites = gql`
  query MyPendingFundClaimInvites {
    myPendingFundClaimInvites {
      id
      token
      fundName
      advisorName
      expiresAt
      isNewFund
    }
  }
`

export const advisorFundClaimInvites = gql`
  query AdvisorFundClaimInvites {
    advisorFundClaimInvites {
      id
      fundId
      fundName
      clientEmail
      clientFirstName
      clientLastName
      corporateName
      fundType
      status
      statusLabel
      expiresAt
      sentAt
      claimedAt
      createdAt
      advisorHasFundAccess
    }
  }
`
